export const slices = {
  auth: "auth",
  invitations: "invitations",
  organizations: "organizations",
  alerts: "alerts",
  resources: "resources",
  roles: "roles",
  users: "users",
  datasets: "datasets",
  executions: "executions",
  camera: "camera",
  datasource: "datasource",
  modelDeployment: "modelDeployment",
  batchPredictionMonitoring: "batchPredictionMonitoring",
  runExecution: "runExecution",
  recurrentBatch: "recurrentBatch",
  prediction: "prediction",
  datasetAnalysis: "datasetAnalysis",
  assets: "assets",
  download: "download",
  applications: "applications",
  monitoringAlerts: "monitoringAlerts",
  connectors: "connectors",
  authorization: "authorization",
  connectMachineWithModels: "connectMachineWithModels",
  cameraGroups: "cameraGroups",
  webrtc: "webrtc",
};
